import _ from "lodash";
/** external */
import React from "react";

/** relative */
import classes from "./Cards.scss";
import Card from "./Card";

const Cards = props => {
  const { options, showSubtext, showIcon, isSingleSelect, onClickCard } = props;
  return (
    <div className={classes.container}>
      {_.map(options, ({ id, label, subText, icon }) => {
        const isSelected = _.includes(props.value, id);
        return (
          <div
            onClick={e => {
              e.preventDefault();
              onClickCard({ id, operation: isSelected ? "remove" : "add" });
            }}
            className={classes.cardContainer}
          >
            <Card
              key={id}
              label={label}
              subtext={subText}
              icon={icon}
              showIcon={showIcon}
              isSelected={isSelected}
              showSubtext={showSubtext}
              isSingleSelect={isSingleSelect}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Cards;
